{
  "info": "Note",
  "tip": "Tip",
  "warning": "Warning",
  "alert": "Alert",
  "remove": "Remove"
}
